import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { useNavigate} from "react-router-dom";
import { format } from "date-fns";

import { getApplicantJobs  } from "../../../api/ApplicantsAPI";
import { fetchCandidateDetailbyID, fetchCandidateSkillbyID, fetchCandidateExperiencebyID, fetchCandidateEducationsbyID, updateBasicInfo, deleteResume } from "../../../api/CandidateAPI";


const ViewJobApplications = () => { 
  const [message, setMessage] = useState({ type: "", text: "" });
  const navigate = useNavigate();
  const token = localStorage.getItem("otoken");
  const companyId = localStorage.getItem("companyId");   
  const { seeker_id } = useParams();
  
  const [loading, setLoading] = useState(false);
   const [jobsData, setJobsData] = useState({
    jobs: []
  });

  const [candidateDet, setCandidateDet] = useState(null);
  const [candidateSkillDet, setCandidateSkillDet] = useState([]);
  const [candidateEducationDet, setCandidateEducationDet] = useState([]);
  const [candidateExperienceDet, setCandidateExperienceDet] = useState([]);
  const [jsId, setJsId] = useState(null);

  useEffect(() => {
     const timer = setTimeout(() => {
      $('#jobListTable').DataTable();
    }, 1000); // wait for DOM to render

  console.log("SEEKER ID : ",seeker_id);
    const handleViewJobs = async () => {
  setLoading(true);

  const data = await getApplicantJobs(companyId, seeker_id, token);

  setJobsData(data || { jobs: [] }); // 👈 SAFETY NET

  setLoading(false);
};


    if (companyId && seeker_id && token) {
        handleViewJobs();
      }
    
    const fetchBasicData = async () => {
      try {
        const data = await fetchCandidateDetailbyID(seeker_id, token);
        setCandidateDet(data);
        setJsId(data.candidate.seeker_id);
      } catch (error) {
        console.error(error);
        setMessage({ type: "error", text: "Could not load profile" });
      }
    };

    const fetchSkillData = async () => {
      try {
        const data = await fetchCandidateSkillbyID(seeker_id, token);
        setCandidateSkillDet(data);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchExperienceData = async () => {
      try {
        const data = await fetchCandidateExperiencebyID(seeker_id, token);
        setCandidateExperienceDet(data);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchEducationData = async () => {
      try {
        const data = await fetchCandidateEducationsbyID(seeker_id, token);
        setCandidateEducationDet(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSkillData();
    fetchExperienceData();
    fetchEducationData();
    fetchBasicData();

    }, [companyId, seeker_id, token]);
  return (
    <div className="content-body">
      <div className="container-fluid mt-3">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    {message.text && (
                      <div
                        className={`alert alert-${message.type} mt-3`}
                        role="alert"
                      >
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                          onClick={() => setMessage({ text: "", type: "" })}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                        {message.text}
                      </div>
                    )}
                    {/* Candidate Profile Card */}
                    {candidateDet?.candidate && (
                      <div className="card mb-3 shadow-sm">
                        <div className="card-body">
                          <div className="row align-items-center">
                            
                            {/* Left: Avatar */}
                            {/* <div className="col-md-2 text-center">
                              <div
                                className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                                style={{ width: 80, height: 80, fontSize: 28 }}
                              >
                                {candidateDet.candidate.full_name?.charAt(0)}
                              </div>
                            </div> */}
                             {/* Profile Image */}
                              <div className="col-md-2 text-center">
                                {candidateDet.candidate.profile_image ? (
                                  <img
                                    src={`${process.env.REACT_APP_C2AS_UPLOAD_URL}/${candidateDet.candidate.auth_user_profile_pic_url}`}
                                    alt="Profile"
                                    className="rounded-circle"
                                    width="80"
                                    height="80"
                                  />
                                ) : (
                                  <div
                                    className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                                    style={{ width: 80, height: 80, fontSize: 28 }}
                                  >
                                    {candidateDet.candidate.full_name?.charAt(0)}
                                  </div>
                                )}
                            </div>
                            {/* Middle: Basic Info */}
                            <div className="col-md-7">
                              <h5 className="mb-1">
                                {candidateDet.candidate.full_name}
                              </h5>

                              <p className="mb-1 text-muted">
                                {candidateDet.candidate.profile_headline || "—"}
                              </p>

                              <div className="d-flex flex-wrap gap-3 mt-2">
                                <span>
                                  📧 {candidateDet.candidate.email}
                                </span>
                                <span>
                                  📞 {candidateDet.candidate.phone_number}
                                </span>
                                <span>
                                  📍 {candidateDet.candidate.current_location || "—"}
                                </span>
                              </div>

                              <div className="mt-2">
                                <strong>Experience:</strong>{" "}
                                {candidateDet.candidate.exp_in_years} yrs{" "}
                                {candidateDet.candidate.exp_in_months} months
                              </div>
                            </div>

                            {/* Right: Resume */}
                            <div className="col-md-3 text-end">
                              {candidateDet.candidate.resume_url ? (
                                <a
                                  href={`${process.env.REACT_APP_JOB_BOARD_RESUME_URL}/${candidateDet.candidate.resume_url}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-outline-primary btn-sm"
                                >
                                  View Resume
                                </a>
                              ) : (
                                <span className="text-muted">
                                  Resume not uploaded
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* ===== Experience ===== */}
                        <div className="card mb-3">
                          <div className="card-header">
                            <strong>Experience</strong>
                          </div>
                          <div className="card-body">
                            {candidateExperienceDet.length > 0 ? (
                              candidateExperienceDet.map((exp, idx) => (
                                <div key={idx} className="mb-3">
                                  <h6 className="mb-0">{exp.designation}</h6>
                                  <small className="text-muted">
                                    {exp.company_name} • {exp.start_date} – {exp.end_date || "Present"}
                                  </small>
                                  <p className="mb-0">{exp.description}</p>
                                </div>
                              ))
                            ) : (
                              <p className="text-muted">No experience added</p>
                            )}
                          </div>
                        </div>
                        {/* ===== Skills ===== */}
                        <div className="card mb-4">
                          <div className="card-header">
                            <strong>Skills</strong>
                          </div>
                          <div className="card-body">
                            {candidateSkillDet.length > 0 ? (
                              candidateSkillDet.map((skill, idx) => (
                                <span
                                  key={idx}
                                  className="badge bg-light text-dark me-2 mb-2"
                                >
                                  {skill.skill_name}
                                </span>
                              ))
                            ) : (
                              <p className="text-muted">No skills added</p>
                            )}
                          </div>
                        </div>

                         {/* ===== Education ===== */}
                    <div className="card mb-3">
                      <div className="card-header">
                        <strong>Education</strong>
                      </div>
                      <div className="card-body">
                        {candidateEducationDet.length > 0 ? (
                          candidateEducationDet.map((edu, idx) => (
                            <div key={idx} className="mb-3">
                              <h6 className="mb-0">{edu.degree}</h6>
                              <small className="text-muted">
                                {edu.institution_name} • {edu.year_of_passing}
                              </small>
                            </div>
                          ))
                        ) : (
                          <p className="text-muted">No education details added</p>
                        )}
                      </div>
                    </div>

                      </div>
                      
                    )}
                   <br/>

                    <div className="d-flex justify-content-between ">
                      <h4 className="card-title mb-0">Jobs Applied</h4>
                      
                    </div>
    
                    <div className="table-responsive mt-2">
                      {loading && <p>Loading...</p>}
                      <table id="jobListTable" className="table table-striped table-bordered mt-2">
                        <thead className="text-center">
                          <tr>
                            <th>Code</th>
                            <th>Job Title</th>
                            <th>Status</th>
                            <th>Applied On</th>
                            {/* <th>Actions</th> */}
                          </tr>
                        </thead>
                        <tbody>
                           {jobsData.jobs.map(job => (
                              <tr key={job.application_id}>
                                <td>{job.job_code}</td>
                                <td>{job.title}</td>
                                <td>{job.status}</td>
                                <td>{format(new Date(job.applied_at), "dd-MM-yyyy")}</td>
                                {/* <td>Change Status</td> */}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </div>
  );
};

export default ViewJobApplications;
